export const DEALERS_BASE_PATH = "/dealers";

export const AUCTION_FLOOR_PATH = "/dealers/dashbord/auction";
export const BUYNOW_FLOOR_PATH = "/dealers/dashbord/buynow";

/** Prefix a dealers-relative path, e.g. path("auction") -> "/dealers/auction" */
export function dealersPath(path = "") {
  if (!path || path === "/") {
    return DEALERS_BASE_PATH;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (
    normalized === DEALERS_BASE_PATH ||
    normalized.startsWith(`${DEALERS_BASE_PATH}/`)
  ) {
    return normalized;
  }
  return `${DEALERS_BASE_PATH}${normalized}`;
}

/** Auction floor (legacy or dashboard-hosted) */
export function isAuctionFloorPath(pathname = "") {
  return (
    pathname === "/dealers/auction" ||
    pathname === AUCTION_FLOOR_PATH ||
    pathname.endsWith("/dashbord/auction")
  );
}

/** Buy-now floor (legacy or dashboard-hosted) */
export function isBuyNowFloorPath(pathname = "") {
  return (
    pathname === "/dealers/buynow" ||
    pathname === BUYNOW_FLOOR_PATH ||
    pathname.endsWith("/dashbord/buynow")
  );
}
